import React from 'react';
import logo from './imgs/logo.png';
import './css/password.css';

export default function Navbar() {
  return (
    <div id="logo">
      <img src={logo} alt="Logo" width="200px" />
    </div>
  );
}
